import AjaxClass from "../Forms/Validation/ajaxClass";

export default function loadServices() {
    $("#load-more").on('click', function(e) {
        e.preventDefault();
        class LoadCards extends AjaxClass {
            successFunction(html) {
                if (html) {
                    $("#cardsDiv").append(html);
                }
                if (!html || parseInt($("#load-more").attr('maxPages')) < parseInt($("#load-more").attr('page'))) {
                    $("#load-more").remove();
                }
            }

            errorFunction() {
            }
        }
        let url = '';
        let page = parseInt($("#load-more").attr('page'));
        let search = $("#load-more").attr('search');
        let tag = $("#load-more").attr('tag');
        $("#load-more").attr('page', page+1);

        let loadPosts = new LoadCards(null, 'get', url, 'html', null);
        loadPosts.dataString = 'page=' + page;
        loadPosts.sendNoRecaptcha();
    });
}